// src/components/SuccessPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';

const SuccessPage = () => {
  const navigate = useNavigate();

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#f5f5f5',
  };

  const messageBoxStyle = {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    maxWidth: '600px',
    width: '100%',
  };

  const headingStyle = {
    fontSize: '2.5em',
    marginBottom: '20px',
    color: '#4CAF50', // Green color for success
  };

  const paragraphStyle = {
    fontSize: '1.2em',
    marginBottom: '20px',
    color: '#333333',
    lineHeight: '1.6',
  };

  const buttonContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    marginTop: '30px',
  };

  const buttonStyle = {
    padding: '10px 20px',
    fontSize: '1em',
    borderRadius: '5px',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  };

  const homeButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#4CAF50',
    color: '#ffffff',
  };

  const addButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#008CBA',
    color: '#ffffff',
  };

  const addButtonHoverStyle = {
    backgroundColor: '#005f6a',
  };

  const homeButtonHoverStyle = {
    backgroundColor: '#367c39',
  };

  // Handler for "Go back to homepage" button
  const handleGoHome = () => {
    navigate('/');
  };

  // Handler for "Add more listings" button
  const handleAddMoreListings = () => {
    // Assuming that App.js listens to a specific route or state to open the popup
    // Here, we'll navigate to the homepage and pass state to trigger the popup
    navigate('/', { state: { openPopup: true } });
  };

  return (
    <div style={containerStyle}>
      <div style={messageBoxStyle}>
        <h1 style={headingStyle}>Payment Successful</h1>
        <p style={paragraphStyle}>
          Thank you for your payment! Your listing details have been successfully received.
          A confirmation email with your listing information has been sent to your email address.
        </p>
        <p style={paragraphStyle}>
          If you have any questions, feel free to contact our support team.
        </p>
        <p style={{ ...paragraphStyle, fontStyle: 'italic', color: '#555555' }}>
          Do you know? On average, <strong>75%</strong> of business traffic will increase after your listings on our platform.
        </p>
        <div style={buttonContainerStyle}>
          <button
            style={homeButtonStyle}
            onClick={handleGoHome}
            onMouseOver={(e) => (e.target.style.backgroundColor = homeButtonHoverStyle.backgroundColor)}
            onMouseOut={(e) => (e.target.style.backgroundColor = homeButtonStyle.backgroundColor)}
          >
            Go back to homepage
          </button>
          <button
            style={addButtonStyle}
            onClick={handleAddMoreListings}
            onMouseOver={(e) => (e.target.style.backgroundColor = addButtonHoverStyle.backgroundColor)}
            onMouseOut={(e) => (e.target.style.backgroundColor = addButtonStyle.backgroundColor)}
          >
            Add more listings
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
